import { Popover } from 'antd'
import cx from 'classnames'
import _ from 'lodash'
import React from 'react'
import { I18n } from 'react-redux-i18n'

class CompositionAttributePopOver extends React.Component {
  getContent () {
    const {value, type} = this.props
    const valueExists = _.isArray(value) && value.length > 1
    return (
      <div>
        <p className={cx('qw-color-text-heading', {'qw-mb-xx-small': valueExists})}>
          {I18n.t(`compositions.attributes.${type}`)}</p>
        {valueExists
          ? value.map((val, idx) => <p key={idx}
                                       className={`attribute popover-attribute ${this.props.type}`}>{val}</p>)
          : null}
      </div>
    )
  }

  render () {
    const {value} = this.props
    return (
      <Popover content={this.getContent()} placement="bottom" overlayClassName='cpl-popover'>
        <p
          className={`attribute qw-border qw-medium-rounded left qw-flex qw-items-center qw-justify-center qw-px-x-small qw-mr-xx-small ${this.props.type} ${this.props.type ===
          'type' && value.toLowerCase()}`}>
          {this.props.icon}
          {_.isArray(value) && value.length > 1 ? `${value[0]}...` : value}
        </p>
      </Popover>
    )
  }
}

export default CompositionAttributePopOver



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionAtttibutePopOver.js